import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { Background } from "../../../foundations/palette.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
const BlockNoticeBodyContainer = styled("div", styledOptions)(({
  isMobile
}) => ({
  padding: isMobile ? Spacing["1000"] : `${Spacing["1000"]} ${Spacing["2500"]}`,
  backgroundColor: Background.paper
}));
export {
  BlockNoticeBodyContainer
};
//# sourceMappingURL=block-notice-body-container.es.js.map
